import React, { Fragment } from "react";
import LayoutOne from "../layouts/LayoutOne";
import PageHeader from '../components/PageHeader';
import Seo from '../components/Seo';

// DRAFT, must be reviewed and approved by the business owner before deployment.
const PrivacyPolicy = () => {
  return (
    <Fragment>
      <Seo
        title="Privacy Policy | Navy Seals Moving"
        description="How Navy Seals Moving collects, uses, and protects your information."
      />
      <LayoutOne>
        <PageHeader
          bgImg={(process.env.PUBLIC_URL + '/assets/images/page_bg.jpg')}
          title="Privacy Policy"
        />
        <section className="about-section">
          <div className="container">
            <div className="row">
              <div className="col-md-10 col-sm-12 about_bottom_warp">
                <div className="about_list privacy-policy-content">

                  <p><em>Last updated: August 2026</em></p>

                  <p>
                    Navy Seals Moving ("we," "us," or "our") operates navysealsmoving.com and its
                    regional sites. This policy explains what information we collect when you use
                    our website or contact us, how we use it, and the choices you have.
                  </p>

                  <h5>Information You Provide</h5>
                  <p>
                    When you request a quote or contact us through our forms, we collect the
                    information you enter: your name, email address, phone number, moving addresses
                    or zip codes, the size of your move, and any message you include. We use this
                    information to respond to your inquiry, prepare your estimate, schedule and
                    perform your move, and keep records of our communication with you.
                  </p>

                  <h5>How Your Information Is Used and Shared</h5>
                  <p>
                    Your information is used only to operate our business: responding to
                    inquiries, providing estimates, and performing moving services. We store it in
                    our customer-management systems and share it with the service providers that
                    make our business work: our email delivery provider (to send you and our team
                    email about your request), our customer relationship management system, and our
                    call tracking provider. We do not sell your personal information, and we do not
                    share it with third parties for their own marketing.
                  </p>

                  <h5>Phone Calls</h5>
                  <p>
                    We use a call tracking service to understand which advertising brings customers
                    to us. Calls to the phone numbers on this website may be tracked and may be
                    recorded for quality and training purposes.
                  </p>

                  <h5>Cookies and Analytics</h5>
                  <p>
                    Like most websites, we use cookies and similar technologies from analytics and
                    advertising services to understand how visitors use our site and to measure our
                    advertising. These include Google Analytics and Google Ads, Meta (Facebook)
                    Pixel, Hotjar (which helps us understand how visitors interact with our pages),
                    and click-fraud protection services. These tools may collect information such
                    as your IP address, browser type, pages visited, and how you reached our site.
                    You can control cookies through your browser settings, and you can opt out of
                    personalized advertising through Google and Meta's ad settings.
                  </p>

                  <h5>Data Retention and Security</h5>
                  <p>
                    We keep inquiry and customer records for as long as needed to serve you and to
                    meet our legal and business obligations. We take reasonable measures to protect
                    your information, though no method of transmission or storage is completely
                    secure.
                  </p>

                  <h5>Your Choices</h5>
                  <p>
                    You may contact us at any time to ask what information we hold about you, to
                    request a correction, or to request deletion of your information where the law
                    allows. Depending on where you live, you may have additional privacy rights
                    under state law.
                  </p>

                  <h5>Contact Us</h5>
                  <p>
                    Navy Seals Moving<br />
                    922 Valley Ave NW, Unit 102<br />
                    Puyallup, WA 98371<br />
                    (206) 636-6961<br />
                    info@navysealsmoving.com
                  </p>

                </div>
              </div>
            </div>
          </div>
        </section>
      </LayoutOne>
    </Fragment>
  );
};

export default PrivacyPolicy;
